import ApiService from "@/common/api.service";

const PATH = "organizations";

export const GET_ORGANIZATIONS_OPTIONS = "getOrganizationsOptions";

const state = {
  //
};

const getters = {
  //
};

const actions = {
  [GET_ORGANIZATIONS_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },
};

const mutations = {
  //
};

export default {
  state,
  actions,
  mutations,
  getters,
};
